"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchField = exports.maxQueryLength = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var SvgIcon_1 = __importDefault(require("@atg/icf-react-components/components/SvgIcon"));
var Events_1 = require("icf-search-client-shared/lib/services/Events");
var react_1 = require("react");
var Contexts_1 = require("../Contexts");
var FocusGroup_1 = require("../utilities/FocusGroup");
var Ioc_1 = require("../utilities/Ioc");
var AutocompleteListContainer_1 = require("./AutocompleteListContainer");
var SearchField_1 = require("./SearchField");
var noHighlightIndex = -1;
exports.maxQueryLength = 35;
var getLabel = function (item, query) {
    switch (item.type) {
        case "tag":
            return item.tag.name;
        case "performer":
            return item.performer.nickname;
        case "video":
            return query;
    }
};
var getAutocompleteClickContext = function (item, query) {
    switch (item.type) {
        case "tag":
            return { keyword: query, tag: item.tag.name };
        case "performer":
            return { keyword: query, performer: item.performer };
        case "video":
            return { keyword: query, video: { kind: "search" } };
    }
};
var SearchFieldInner = function (_a) {
    var emitTrackingEvent = _a.emitTrackingEvent, filters = _a.filters, navigateTo = _a.navigateTo, getPerformerLinkTo = _a.getPerformerLinkTo, getTagLinkTo = _a.getTagLinkTo, getVideoLinkTo = _a.getVideoLinkTo, maxVisibleItems = _a.maxVisibleItems, onSubmitSearch = _a.onSubmitSearch, eventPublisher = _a.eventPublisher, autocompleteService = _a.autocompleteService, translate = _a.translationService.translate, layout = _a.layout, sakey = _a.sakey, statsdClient = _a.statsdClient, theme = _a.theme;
    var _b = __read((0, react_1.useState)(false), 2), isFocused = _b[0], setFocused = _b[1];
    var _c = __read((0, react_1.useState)(noHighlightIndex), 2), selectedItemIndex = _c[0], setSelectedItem = _c[1];
    var _d = __read((0, react_1.useState)(""), 2), query = _d[0], setQuery = _d[1];
    var _e = __read((0, react_1.useState)([]), 2), autocompleteItems = _e[0], setAutoCompleteItems = _e[1];
    var textElement = (0, react_1.useRef)(null);
    var gender = filters && filters.gender ? filters.gender.value : null;
    function updateQuery(newQuery) {
        if (newQuery === query) {
            return;
        }
        var safeNewQuery = newQuery;
        if (newQuery && newQuery.length > exports.maxQueryLength) {
            safeNewQuery = newQuery.substr(0, exports.maxQueryLength);
        }
        setQuery(safeNewQuery);
        autocompleteService.getItems({
            tagCount: 5,
            performerCount: 5,
            query: safeNewQuery,
            genderFilter: { name: "gender", value: gender || "", isBoosted: false },
        }, sakey, function (items) {
            var newItems = items.filter(function (item) { return !!item; });
            if (safeNewQuery && items.length > 0) {
                // Add the video store search to the autocomplete list
                newItems.push({ type: "video" });
            }
            setAutoCompleteItems(newItems);
        });
    }
    var isLayoutLarge = layout.breakpoint === "large";
    var resetAutocomplete = function () {
        setAutoCompleteItems([]);
        setSelectedItem(noHighlightIndex);
        updateQuery("");
        textElement.current.value = "";
    };
    (0, react_1.useEffect)(resetAutocomplete, [gender]);
    var getLinkTo = function (item, query) {
        switch (item.type) {
            case "tag":
                return getTagLinkTo(item.tag);
            case "performer":
                return getPerformerLinkTo(item.performer);
            case "video":
                return getVideoLinkTo(query);
        }
    };
    var sanitizeQuery = function (query) {
        return escape(query.trim().toLowerCase().substr(0, exports.maxQueryLength));
    };
    var handleEnter = function (e) {
        if (selectedItemIndex === noHighlightIndex) {
            if (e.target.value.length > 0 &&
                e.target.value.length <= exports.maxQueryLength) {
                onSubmitSearch(e.target.value);
                statsdClient && statsdClient.count("searchField.submitSearch");
                emitTrackingEvent("icfClick", "submitSearch", "searchQueryData=".concat(sanitizeQuery(e.target.value)));
            }
        }
        else {
            var item = autocompleteItems[selectedItemIndex];
            var eventContext = getAutocompleteClickContext(item, query);
            eventContext && (eventPublisher === null || eventPublisher === void 0 ? void 0 : eventPublisher.send(Events_1.Events.autocompleteResultClick, eventContext, undefined, false));
            statsdClient && statsdClient.count("searchField.autocompleteResult.click");
            emitTrackingEvent("icfClick", "autocompleteResult", "label=".concat(item.type));
            switch (item.type) {
                case "tag":
                    navigateTo(getTagLinkTo(item.tag));
                    break;
                case "performer":
                    navigateTo(getPerformerLinkTo(item.performer));
                    break;
                case "video":
                    navigateTo(getVideoLinkTo(query));
                    break;
            }
        }
    };
    var handleKeyDown = function (e) {
        var lastIndex = autocompleteItems.length - 1;
        switch (e.key) {
            case "ArrowUp":
                e.preventDefault();
                setSelectedItem(selectedItemIndex >= 0 ? selectedItemIndex - 1 : lastIndex);
                break;
            case "ArrowDown":
                e.preventDefault();
                setSelectedItem(selectedItemIndex < lastIndex ? selectedItemIndex + 1 : noHighlightIndex);
                break;
            case "Enter":
                handleEnter(e);
                resetAutocomplete();
                setFocused(false);
                break;
            default:
                setFocused(true);
                break;
        }
    };
    var focusProps = {
        onBlur: function () { return setFocused(false); },
        onFocus: function () { return setFocused(true); },
    };
    var textInputProps = {
        name: "search",
        placeholder: translate("search.search_hint_basic"),
        type: "search",
        // TODO: Don't know why React's event element type isn't forwarded to the target property
        onChange: function (e) { return updateQuery(e.target.value); },
        onKeyDown: function (e) { return handleKeyDown(e); },
        autoCorrect: "off",
        autoCapitalize: "off",
        autoComplete: "off",
        spellCheck: false,
        "data-ta-locator": "SearchField-TextInput",
        ref: textElement,
        maxLength: exports.maxQueryLength,
    };
    var buttonProps = {
        tabIndex: -1,
        onClick: function () {
            onSubmitSearch(query);
            statsdClient && statsdClient.count("searchField.submitSearch");
            emitTrackingEvent("icfClick", "submitSearch", "searchQueryData=".concat(sanitizeQuery(query)));
        },
        "data-ta-locator": "SearchField-IconButton",
    };
    // @ts-ignore - TODO: This is missing list item height. Did some debugging, but have had difficulty tracking it down.
    var items = autocompleteItems.map(function (item, index) { return ({
        item: item,
        index: index,
        isSelected: index === selectedItemIndex,
        label: getLabel(item, query),
        linkTo: getLinkTo(item, query),
        onClick: function () {
            var eventContext = getAutocompleteClickContext(item, query);
            eventContext && (eventPublisher === null || eventPublisher === void 0 ? void 0 : eventPublisher.send(Events_1.Events.autocompleteResultClick, eventContext, undefined, false));
            statsdClient && statsdClient.count("searchField.autocompleteResult.click");
            emitTrackingEvent("icfClick", "autocompleteResult", "label=".concat(item.type));
            resetAutocomplete();
        },
    }); });
    var autocompleteProps = {
        keyword: query,
        items: items,
        maxVisibleItems: maxVisibleItems,
        shouldUseHeaderStyles: isLayoutLarge,
    };
    var styles = (0, SearchField_1.useSearchFieldStyles)({
        shouldUseHeaderStyles: isLayoutLarge,
        color: isLayoutLarge ? theme.colors.baseContrast070 : theme.colors.textOnLight,
    });
    return ((0, jsx_runtime_1.jsxs)(FocusGroup_1.FocusGroup, __assign({}, focusProps, { children: [(0, jsx_runtime_1.jsxs)("div", { className: styles.keywordField, "data-ta-locator": "SearchField", children: [(0, jsx_runtime_1.jsx)("input", __assign({ className: styles.textInput }, textInputProps)), (0, jsx_runtime_1.jsx)("button", __assign({ className: styles.button }, buttonProps, { children: (0, jsx_runtime_1.jsx)(SvgIcon_1.default, { name: "search", fill: "baseContrast050" }) }))] }), isFocused && (0, jsx_runtime_1.jsx)(AutocompleteListContainer_1.AutocompleteListContainer, __assign({}, autocompleteProps))] })));
};
var SearchField = function (props) {
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.IEventPublisherContext, Contexts_1.ITranslationServiceContext, Contexts_1.ILayoutContext, Contexts_1.IThemeContext, Contexts_1.IStatsdClientContext, Contexts_1.IAutocompleteServiceContext, Contexts_1.IXmentServiceContext), 6), eventPublisher = _a[0], translationService = _a[1], layout = _a[2], theme = _a[3], statsdClient = _a[4], autocompleteService = _a[5];
    return ((0, jsx_runtime_1.jsx)(SearchFieldInner, __assign({}, props, { eventPublisher: eventPublisher !== null && eventPublisher !== void 0 ? eventPublisher : undefined, translationService: translationService, layout: layout, theme: theme, statsdClient: statsdClient !== null && statsdClient !== void 0 ? statsdClient : undefined, autocompleteService: autocompleteService })));
};
exports.SearchField = SearchField;
//# sourceMappingURL=SearchFieldContainer.js.map